import React from 'react';

import styles from './Speech.module.scss';

interface SpeechProps {
  variant?: 'liquid' | 'solid';
  children: React.ReactNode;
  className?: string;
}

export const Speech: React.FC<SpeechProps> = ({ children, variant = 'solid', className }) => {
  return (
    <div className={`${styles.speech} ${styles[`--${variant}`]} ${className || ''}`}>
      <p className={styles.content}>{children}</p>
    </div>
  );
};
